export default "__VITE_ASSET__5kwyKpGl__"